module.exports = __webpack_public_path__ + "img/金属材料学3_3.ce34a65b.png";